import React, { useState, useMemo } from 'react';
import Actions from '@components/Actions';
import Marquee from '@components/Marquee';

import { formatRoute, integrationRoute } from '@util/routes';

import * as styles from './SingleRowMarquee.module.css';
import CardWithLogo from '@components/CardWithLogo';

const CardsMarquee = ({ items, repeatCount = 2 }) => {
  const [isPlaying, setIsPlaying] = useState(true);

  const MARQUEE_BASE_SPEED = 0.2;

  const totalItems = items.length;

  const speed = useMemo(() => {
    const speed = MARQUEE_BASE_SPEED / totalItems;
    return Math.max(0.0125, speed);
  }, [totalItems]);

  return (
    <div
      className={styles.marquee}
      onPointerEnter={() => setIsPlaying(false)}
      onPointerLeave={() => setIsPlaying(true)}
    >
      <Marquee
        repeatCount={repeatCount}
        speed={speed}
        shouldPlay={isPlaying}
        onlyPlayInView={false}
        style={{
          '--marquee-item-gap': 'var(--space-m)',
        }}
      >
        {items.map((item) => {
          return (
            <div className={styles.card} key={item.logoId}>
              <CardWithLogo
                title={item.name}
                logo={item.logoId}
                href={
                  item.type === 'format'
                    ? formatRoute(item.slug)
                    : integrationRoute(item.slug)
                }
              />
            </div>
          );
        })}
      </Marquee>
    </div>
  );
};

export const SingleRowMarquee = ({ items, actions }) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div className={styles.root}>
      <div className={styles.wrapper}>
        <CardsMarquee items={items} />
        <div className={styles.action}>
          <Actions actions={actions} />
        </div>
      </div>
    </div>
  );
};
